import React from "react";
import { MainLayout } from "layout/MainLayout";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { NewCourseSuggestionsPage } from "pages/courseSuggestions/NewCourseSuggestionsPage";
import { ProcessedCourseSuggestionsPage } from "pages/courseSuggestions/ProcessedCourseSuggestionsPage";

export const CourseSuggestionPage = () => {
  const [selectedTab, setSelectedTab] = React.useState(0);

  const handleTabChange = (event, newSelectedTab) => {
    setSelectedTab(newSelectedTab);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <MainLayout>
        <Typography variant="h3" className="rounded px-3 px-sm-4 py-3 py-sm-5">
          Neue Kursvorschläge
        </Typography>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              aria-label="basic tabs example"
            >
              <Tab label="Neue Kursvorschläge" {...a11yProps(0)} />
              <Tab
                label="Bereits bearbeitete Kursvorschläge"
                {...a11yProps(1)}
              />
            </Tabs>
          </Box>
          {selectedTab === 0 && <NewCourseSuggestionsPage />}
          {selectedTab === 1 && <ProcessedCourseSuggestionsPage />}
        </Box>
      </MainLayout>
    </>
  );
};
